module.exports = __webpack_public_path__ + "static/designblok-83016399bb6384c6c517554538d5b55f.png";